export default __webpack_public_path__ + "static/media/exam.c833648a.png";